import { render, staticRenderFns } from "./AntiFake.vue?vue&type=template&id=6515dbb3&scoped=true&"
import script from "./AntiFake.vue?vue&type=script&lang=js&"
export * from "./AntiFake.vue?vue&type=script&lang=js&"
import style0 from "./AntiFake.vue?vue&type=style&index=0&id=6515dbb3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6515dbb3",
  null
  
)

export default component.exports